import React from "react";
import { useState, useEffect } from "react";
import { Process } from "model/processModel";
import { useSelectedOrganization } from "hooks";
import { baseApi, processmodelsApi } from "api";
//import axios from "axios";

//@ts-ignore
import BpmnModeler from "bpmn-js/lib/Modeler";
import Selection from "diagram-js/lib/features/selection/Selection";
//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import MenuItem from "@mui/material/MenuItem";
import { ProcessModelDataTypes } from "hooks/useBpmnModeler/useBpmnJsModeler";
import RunTimeAssignmentFields from "./RunTimeAssignmentFields";
import TimerConfigurationPanel from "./TimerConfigurationPanel";

import { useSnackbar, useTranslations } from "hooks";
import { getTranslation } from "common";
import {
  Stack,
  TextField,
  Button,
  Typography,
  ListItemButton,
  ListItemText,
  Collapse,
  Box,
} from "@mui/material";
import { ExpandLess, ExpandMore, Timer } from "@mui/icons-material";
import { ExtensionElementType } from "model/processModel";
import { useParams } from "react-router-dom";
import { Data } from "components/dialogs/ProcessModelSchema";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";

// interface Swimlane {
//   idpool: number;
//   assignmentmode: number;
//   flownoderef: string[];
//   name: string;
//   designerid: string;
//   documentation: string;
//   idprocessmodel: number;
//   id: number;
// }

interface SpecificPropertiesPanelTypes {
  isRobotSwimlane: boolean;
  robotId?: number | null;
  toggleSpecificPropertiesAccordian: boolean;
  setToggleSpecificPropertiesAccordian: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  element: any;
  modeler: BpmnModeler;
  timerType: string;
  setTimerType: (value: string) => void;
  timeDateValue: Date | null;
  setTimeDateValue: (value: Date | null) => void;
  processModelData: ProcessModelDataTypes;
  getRequestBodyForExtensionElements: () => Array<ExtensionElementType>;
  setProcessModelData: (data: ProcessModelDataTypes) => void;
  // getSelectedLanguage: () => string;
  openDiagram: (
    xml: string,
    shouldShowInTheViewPort: boolean,
    onSuccess?: () => void
  ) => Promise<void>;
  selectedDuration: {
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
  };
  setSelectedDuration: (value: {
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
  }) => void;
  onTriggerAutosave?: () => void;
  schema: Data[];
  idToUse: string | number | undefined;
  robotDialogOpen?: (isOpen: boolean) => void;
  robotValidationRef?: React.MutableRefObject<(() => boolean) | null>;
}

const SpecificPropertiesPanel: React.FC<SpecificPropertiesPanelTypes> = ({
  toggleSpecificPropertiesAccordian,
  setToggleSpecificPropertiesAccordian,
  element,
  modeler,
  timerType,
  setTimerType,
  timeDateValue,
  setTimeDateValue,
  processModelData,
  getRequestBodyForExtensionElements,
  setProcessModelData,
  // getSelectedLanguage,
  openDiagram,
  selectedDuration,
  setSelectedDuration,
  onTriggerAutosave,
  isRobotSwimlane,
  robotId,
  schema,
  idToUse,
  robotDialogOpen,
  robotValidationRef
}) => {
  const translations = useTranslations();
  const [timerDialog, setTimerDialog] = useState<boolean>(false);
  const { sendSnack } = useSnackbar();
  const { editId } = useParams();
  const [processModels, setProcessModels] = useState<
    Array<Process & { _name: string }>
  >([]);
  const [selectedOption, setSelectedOption] = useState<number | null>(
    processModelData.extensionsubprocesses.find(
      (elem) => elem.source === element.id
    )?.eventid || null
  );
  const [enableAssignment, setEnableAssignment] = useState(true);
  const [loading, setLoading] = useState(false);
  const selectedOrganization = useSelectedOrganization();

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      const { xml } = await modeler
        .saveXML()
      const payload = {
        ...processModelData,
        model: xml,
        extensionelements: getRequestBodyForExtensionElements(),
      }
      setLoading(true)
      try {
        if (element.type === "bpmn:Lane") {
          const result = await baseApi.post<{ flownoderef?: string[] }>(`processmodels/flownodesref/${element.id}`,
            payload,
            { signal: controller.signal })
          if (result.data.flownoderef && result.data.flownoderef.length > 0) {
            const _enableAssignment = !processModelData.extensionflownodes.some(flownode => result.data.flownoderef?.includes(flownode.source))
            setEnableAssignment(_enableAssignment)
          } else {
            setEnableAssignment(true)
          }
        }
        else if (element.type === "bpmn:Participant") {
        }
        else {
          // const result = await baseApi.post<{ swimlane: Swimlane }>(`/processmodels/swimlanes/${element.id}`,
          //   payload,
          //   { signal: controller.signal }
          // )
          if (processModelData.extensionswimlanes.length > 0) {
            const _enableAssignment = !processModelData.extensionswimlanes.find(
              extensionswimlane => extensionswimlane.assignmentmode !== 0
            );
            setEnableAssignment(_enableAssignment)
          } else {
            setEnableAssignment(true)
          }
        }
      }
      catch { }
      finally {
        setLoading(false)
      }
    })
      ();
    return () => { controller.abort() }
  }, [element, getRequestBodyForExtensionElements, modeler, processModelData]);

  useEffect(() => {
    (async () => {
      const res = await baseApi.get(
        `startevents/organizations/${selectedOrganization?.id}`
      );
      setProcessModels(
        res.data.possiblestart.map((_: Process) => ({
          ..._,
          _name:
            _.name === ""
              ? _.processmodelname
              : _.processmodelname + " (" + _.name + ")",
        }))
      );
    })();
  }, [selectedOrganization]);

  const SubprocessSpecificProperties = () => {
    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const id = parseInt(event.target.value);
      const selectedProcessModel = processModels.find((_) => _.id === id);
      if (id) {
        setSelectedOption(id);
        try {
          const { xml } = await modeler.saveXML();
          const response = await processmodelsApi.post(
            `/subprocess/currentflownode/${element.id}?eventid=${id}&name=${selectedProcessModel?._name}`,
            {
              ...processModelData,
              model: xml?.replaceAll("#ff0000", "#000000"),
              extensionelements: getRequestBodyForExtensionElements(),
            }
          );

          let newProcessModelData = {
            ...processModelData,
            ...response.data,
          };

          setProcessModelData(newProcessModelData);

          await openDiagram(response.data.model, false);
          let elementRegistry = modeler.get("elementRegistry") as any;
          let selectedElement: any = elementRegistry.get(element.id);
          const selection = modeler.get("selection") as Selection;
          selection.select(selectedElement);
          // selection.select([element]);
        } catch (error) { }
      }
    };
    const options = processModels.filter(
      (_) => String(_.idprocessmodel) !== String(editId)
    );
    return (
      <Stack spacing={2}>
        {options.length > 0 && (
          <TextField
            disabled={
              processModels.filter(
                (_) => String(_.idprocessmodel) !== String(editId)
              ).length <= 0
            }
            id="model-association-btn"
            select
            label={getTranslation(translations, "pm.modelname.label.caption")}
            fullWidth
            size="small"
            margin="normal"
            value={selectedOption || ""}
            onChange={handleChange}
          >
            {options.map((option) => (
              <MenuItem
                id={`model-${option.id}`}
                key={option.id}
                value={option.id}
              >
                {option._name}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Stack>
    );
  };

  const getShouldShowTimerTypeField = () => {
    const bo = getBusinessObject(element);
    const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;

    return (
      (element.type === "bpmn:StartEvent" && isTimerEvent) ||
      element.type === "bpmn:IntermediateCatchEvent" ||
      isTimerEvent
    );
  };
  const getShouldShowDuration = () => {
    return (
      element.type === "bpmn:IntermediateCatchEvent" ||
      element.type === "bpmn:BoundaryEvent"
    );
  };

  const shouldShowRunTimeAssignmentModeForLane = () => {
    return element.type === "bpmn:Lane";
  };
  const shouldShowRunTimeAssignmentMode = () => {
    return (
      element.type === "bpmn:ExclusiveGateway" ||
      element.type === "bpmn:InclusiveGateway" ||
      element.type === "bpmn:Task" ||
      element.type === "bpmn:SubProcess"
    );
  };

  const shouldShowSpecificProperties = () => {
    return (
      shouldShowRunTimeAssignmentMode() ||
      shouldShowRunTimeAssignmentModeForLane() ||
      getShouldShowTimerTypeField()
    );
  };

  const shouldShowCycleOption = () => {
    const bo = getBusinessObject(element);
    const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;

    return element.type === "bpmn:StartEvent" && isTimerEvent;
  };


  if (!shouldShowSpecificProperties()) {
    return null;
  }
  return (
    <React.Fragment>
      <ListItemButton
        onClick={() => setToggleSpecificPropertiesAccordian((prev) => !prev)}
      >
        <ListItemText
          primary={getTranslation(
            translations,
            "pm.propertyeditor.specificproperties"
          )}
        />
        {toggleSpecificPropertiesAccordian ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse
        sx={{ pt: 2 }}
        timeout="auto"
        unmountOnExit
        in={toggleSpecificPropertiesAccordian}
      >
        {/* senza di questo pezzetto succedeva che: Uncaught Error: Rendered fewer hooks than expected. This may be caused by an accidental early return statement in React Hooks */}
        <Box
          style={{
            display: element.type === "bpmn:SubProcess" ? "block" : "none",
          }}
        >
          {SubprocessSpecificProperties()}
        </Box>
        <Box
          style={{
            display: element.type !== "bpmn:SubProcess" ? "block" : "none",
          }}
        >
          <RunTimeAssignmentFields
            selectedOrganizationId={selectedOrganization?.id || 0}
            isRobotSwimlane={isRobotSwimlane}
            robotId={robotId}
            enableAssignment={enableAssignment}
            loadingFlowNodeState={loading}
            element={element}
            shouldShowRunTimeAssignmentModeForLane={
              shouldShowRunTimeAssignmentModeForLane
            }
            shouldShowRunTimeAssignmentMode={shouldShowRunTimeAssignmentMode}
            modeler={modeler}
            processModelData={processModelData}
            getRequestBodyForExtensionElements={
              getRequestBodyForExtensionElements
            }
            setProcessModelData={setProcessModelData}
            openDiagram={openDiagram}
            schema={schema}
            idToUse={idToUse}
            robotDialogOpen={robotDialogOpen}
          />
          {getShouldShowTimerTypeField() && (
            <Stack spacing={2} alignItems="flex-start">
              <FlowentiButton
                onClick={() => setTimerDialog(true)}
                variant="contained"
                startIcon={<Timer />}
              >
                {getTranslation(
                  translations,
                  "pm.propertyeditor.specificproperties.label.timer_type"
                )}
              </FlowentiButton>

              {timerType && timerType !== "" && (
                <Typography variant="caption" color="text.secondary">
                  {getTranslation(
                    translations,
                    "pm.propertyeditor.specificproperties.label.timer_type"
                  )}: <strong>{timerType}</strong>
                </Typography>
              )}

              <TimerConfigurationPanel
                open={timerDialog}
                onClose={() => setTimerDialog(false)}
                modeler={modeler}
                element={element}
                onTriggerAutosave={onTriggerAutosave}
                showDurationOption={getShouldShowDuration()}
                showCycleOption={shouldShowCycleOption()}
                selectedDuration={selectedDuration}
                setSelectedDuration={setSelectedDuration}
                timeDateValue={timeDateValue}
                setTimeDateValue={setTimeDateValue}
                timerType={timerType}
                setTimerType={setTimerType}
              />
            </Stack>
          )}
        </Box>
      </Collapse>
    </React.Fragment>
  );
};

export default SpecificPropertiesPanel;